import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { PATH_URL } from "src/interfaces";
import "./index.scss";
import { ArrowRightIcon } from "src/assets/icons";

interface IProps {
  isResale?: boolean;
}

function MenuListComponent({ isResale }: IProps) {
  const { t } = useTranslation();
  const navigrate = useNavigate();

  const list = [
    {
      name: t("reservation_list.menu_reservation_top"),
      icon: <></>,
      path: "",
      route: "",
    },
    {
      name: t("reservation_list.menu_member_information"),
      icon: <ArrowRightIcon height={20} />,
      path: PATH_URL.USER_PROFILE,
      route: "",
    },
    {
      name: t("reservation_list.menu_reservation_list"),
      icon: <ArrowRightIcon height={20} />,
      path: `${
        isResale ? PATH_URL.RESALE_RESERVATION_LIST : PATH_URL.RESERVATION_LIST
      }`,
      route: "reservation",
    },
    {
      name: t("reservation_list.menu_message"),
      icon: <ArrowRightIcon height={20} />,
      path: "",
      route: "",
    },
    {
      name: t("reservation_list.menu_sale_management"),
      icon: <ArrowRightIcon height={20} />,
      path: PATH_URL.SALE_MANAGEMENT,
      route: "",
    },
  ];

  const { pathname } = useLocation();

  return (
    <>
      {list.map((item, index) => {
        const isActive = () => {
          if (item.path.length === 1) return pathname === item.path;
          return (
            item.path.replace("/", "").includes(pathname.replace("/", "")) ||
            (item.route.length && pathname.includes(item.route))
          );
        };

        return (
          <div
            key={index}
            className={`menu-item ${isActive() ? "menu-active" : ""}`}
            onClick={() => {
              if (item.path) {
                return navigrate(`${item.path}?menu=${index}`);
              }
            }}
          >
            {item.name}
            {item.icon}
          </div>
        );
      })}
    </>
  );
}

export default MenuListComponent;
